

export const checkEnglishName = (rule, value, callback)=> {
    if(value) {
        let reg = new RegExp("^[a-zA-Z]+$")
        if(!reg.test(value)) {
            callback(new Error('输入内容必须纯英文'))
        }else {
            callback();
        }
    }
    callback();
}

export const checkPhone = (rule, value, callback) => {
  let phoneReg = /^1[3456789]\d{9}$/
  if (phoneReg.test(value)) {
    callback()
  } else {
    callback(new Error('手机号格式错误'))
  }
}
export const checkEmail = (rule, value, callback) => {
  let emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  if (emailReg.test(value)) {
    callback()
  } else {
    callback(new Error('邮箱格式错误'))
  }
}

// export function checkCardId (rule,value,callback,itemValue) {
//   if (itemValue === '1') {
//     let cardReg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
//     if (cardReg.test(value)) {
//       callback()
//     } else {
//       callback(new Error('身份证格式错误'))
//     }
//   } else {
//     callback()
//   }
// }

export function checkCardId (rule,value,callback,itemValue) {
  if (itemValue === '1') {
    if (checkidnumber(value)) {
      callback()
    } else {
      callback(new Error('身份证格式错误'))
    }
  } else {
    callback()
  }
}

export function checkPwd_pure (value) {
  var reg = /^[a-zA-Z]([-_a-zA-Z0-9]{5,17})$/
    
  return reg.test(value)
    
}

// 密码校验（原）
export function checkPwd (rule, value, callback) {
  var reg = /^[a-zA-Z]([-_a-zA-Z0-9]{5,17})$/
  if (value) {

    if (!reg.test(value)) {
      callback(new Error('长度在6-20之间，以字母开头且只能包含字母和数字'));

    } else {
      callback();
    }
  }
  callback();
}


const charTable_ns = [
  ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""],
  ["", "q", "w", "e", "r", "t", "y", "u", "i", "o", "p", ""],
  ["", "a", "s", "d", "f", "g", "h", "j", "k", "l", ""],
  ["", "z", "x", "c", "v", "b", "n", "m", ""]
];

const charTable_s = [
  // ["~", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "_", "+", ""],
  ["", "q", "w", "e", "r", "t", "y", "u", "i", "o", "p", ""],
  ["", "a", "s", "d", "f", "g", "h", "j", "k", "l", ""],
  ["", "z", "x", "c", "v", "b", "n", "m", ""]
];

// 密码校验（现）
export function passWordStrength (rule, value, callback) {
    let first = /^.{8,20}$/;
    let third = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':",.<>\/?])/;
    let userName = '';
    let flag = false;
    if (window.localStorage.getItem("userInfo")) {
      flag = true;
      userName = JSON.parse(window.localStorage.getItem("userInfo")).userName;
    }
    var five = /([A-Za-z0-9])\1{2}/g;
    if (!first.test(value)){
      callback(new Error('长度必须是8-20位之间！'));
    } 
    else if (!JPStr(value)) {
      callback(new Error('不能包含键盘上连续三位及以上字母或数字！'));
    }
    else if (!third.test(value)) {
      callback(new Error('必须包含大小写字母、数字、特殊符号！'));
    } 
    else if(!LxStr(value)) {
      callback(new Error('不能包含三位及以上连续的字母或数字！'));
    } 
    else if(five.test(value)) {
      callback(new Error('不能包含三位及以上相同的字母或数字！'));
    } 
    else if (value.indexOf(userName) !== -1 && flag) {
      callback(new Error('不能包含与用户名相同的内容。'));
    } 
    
    // 连续校验
    function LxStr(value){
      var arr = value.split('');
      var flag = true;
      for (var i = 1; i < arr.length-1; i++) {
        var firstIndex = arr[i-1].charCodeAt();
        var secondIndex = arr[i].charCodeAt();
        var thirdIndex = arr[i+1].charCodeAt();
        thirdIndex - secondIndex == 1 || secondIndex - thirdIndex == 1;
        secondIndex - firstIndex == 1 || firstIndex - secondIndex == 1;
        if(((thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex==1)) || ((secondIndex - thirdIndex == 1)&&(firstIndex - secondIndex == 1))){
          flag =  false;
        }
      }
      if(!flag){
        return flag;
      }
      return flag;
    }

    let charAll = []
    function getCharAll() {
      charAll = []
      // 横向所有的值(正序和反序)-
      charTable_ns.concat(charTable_s).forEach((item, index) => {
        charAll.push(item.join(''), Object.assign([], item).reverse().join(''))
      })
      // 反斜杠纵向所有的值(正序和反序)\
      // for (let i = 0; i < charTable_ns[0].length; i++) {
      //   let sb1 = []
      //   let sb2 = []
      //   charTable_ns.forEach(item => {
      //     sb1.push(item[i])
      //   })
      //   charTable_s.forEach(item => {
      //     sb2.push(item[i])
      //   })
      //   // 去除长度小于3的值
      //   sb1.join('').length < 3 || charAll.push(sb1.join(''), Object.assign([], sb1).reverse().join(''))
      //   sb1.join('').length < 3 || charAll.push(sb2.join(''), Object.assign([], sb2).reverse().join(''))
      // }
      
      // 正斜杠纵向所有的值(正序和反序)/
      // for (let i = 0; i < charTable_ns[0].length; i++) {
      //   let sb1 = []
      //   let sb2 = []
      //   charTable_ns.forEach((item, index) => {
      //     i - index < 0 || sb1.push(item[i - index])
      //   })
      //   charTable_s.forEach((item, index) => {
      //     i - index < 0 || sb2.push(item[i - index])
      //   })
      //   // 去除长度小于3的值
      //   sb1.join('').length < 3 || charAll.push(sb1.join(''), Object.assign([], sb1).reverse().join(''))
      //   sb1.join('').length < 3 || charAll.push(sb2.join(''), Object.assign([], sb2).reverse().join(''))
      // }
      // charAll.push('abcdefghijklmnopqrstuvwxyz')
      return charAll
    }


    // 不能包含三位及以上连续的字母或数字，例如 “abc、cba" 等

    // 校验键盘连续性和连续重复
    function JPStr(val) {
      getCharAll();
      let password = val.toLowerCase();
      // 密码3位比对
      for (let i = 0; i < password.length - 2; i++) {
        let n1 = password[i];
        let n2 = password[i + 1];
        let n3 = password[i + 2];
        if (charAll.some(item => { return item.includes(n1 + n2 + n3) })) {
          return false
        }
      }
      return true;
    }
    callback();
}


// 身份证校验
export function checkidnumber (value) {
  value = value.toUpperCase(); //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value))) {
      //alert('输入的身份证号长度不对，或者号码不符合规定！\n15位号码应全为数字，18位号码末位可以为数字或X。');
      return false;
  } //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
  //下面分别分析出生日期和校验位
  var len, re;
  len = value.length;
  if (len == 15) {
      re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
      var arrSplit = value.match(re); //检查生日日期是否正确
      var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      var bGoodDay;
      bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
          //alert('输入的身份证号里出生日期不对！');
          return false;
      } else { //将15位身份证转成18位 //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var nTemp = 0,
              i;
          value = value.substr(0, 6) + '19' + value.substr(6, value.length - 6);
          for (i = 0; i < 17; i++) {
              nTemp += value.substr(i, 1) * arrInt[i];
          }
          value += arrCh[nTemp % 11];
          return true;
      }
  }
  if (len == 18) {
      re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
      var arrSplit = value.match(re); //检查生日日期是否正确
      var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
      var bGoodDay;
      bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
          //alert(dtmBirth.getYear());
          //alert(arrSplit[2]);
          //alert('输入的身份证号里出生日期不对！');
          return false;
      } else { //检验18位身份证的校验码是否正确。 //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          var valnum;
          var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var nTemp = 0,
              i;
          for (i = 0; i < 17; i++) {
              nTemp += value.substr(i, 1) * arrInt[i];
          }
          valnum = arrCh[nTemp % 11];
          if (valnum != value.substr(17, 1)) {
              //alert('18位身份证的校验码不正确！应该为：' + valnum);
              return false;
          }
          return true;
      }
  }
}

// 纯数字校验
export function checkNumber (rule, value, callback, max) {
  // if (!value) { return callback(new Error('请输入'))}
  if (isNaN(Number(value))) {
    return callback(new Error('请输入数值'))
  }
  if (!max || max && isNaN(Number(max))) {
    max = Number.MAX_VALUE
  }
  if (value > max) {
    callback(new Error(`超过最大值${max}，请输入有效数值`))
  } else {
    callback()
  }
}

// 不可输入汉字校验
export function checkChinese (rule, value, callback) {
  if (value) {
    if (/[\u4E00-\u9FA5]/g.test(value)) {
      callback(new Error('用户名称不能输入汉字!'));
    } else {
      callback();
    }
  }
  callback();
}
